export const RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST =
	'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';
